<picture>
  <!-- Handle Mobile -->
  <ng-container *ngIf="mobileSrc">
    <source [attr.srcset]="mobileSrc" media="(max-width: 990px)" />
  </ng-container>
  <!-- Handle responsive srcset -->
  <ng-container *ngIf="Array.isArray(resolvedSrc)">
    <source
      *ngFor="let item of resolvedSrc"
      [attr.srcset]="item.src"
      [attr.media]="item.media"
    />
  </ng-container>

  <!-- Fallback for single image or default resolution -->
  <img
    [attr.src]="Array.isArray(resolvedSrc) ? resolvedSrc[0].src : resolvedSrc"
    [attr.alt]="alt"
    [attr.title]="title"
    [attr.width]="width"
    [attr.height]="height"
    (load)="onImageLoad($event)"
    [loading]="lazy ? 'lazy' : 'eager'"
    data-type="image"
  />
</picture>
